import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";
import FilterSelectApi from "../FilterSelectApi";
import moment from "moment";
import FilterTimeFromTo from "../FilterTimeFromTo";

function FilterTicketOrder({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    ma: "",
    ten_kh: "",
    ma_ghe: "",
    tg_khoi_hanh_start: "",
    tg_khoi_hanh_end: "",
    xe_khach: null,
    trang_thai: null,
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.ma) {
      condition.ma = { $regex: filter.ma, $options: "i" };
    }
    if (filter.ten_kh) {
      condition.ten_kh = {
        $regex: filter.ten_kh?.split(" ").join(".*"),
        $options: "i",
      };
    }
    if (filter.ma_ghe) {
      condition.ma_ghe = {
        $regex: filter.ma_ghe,
        $options: "i",
      };
    }
    if (filter.xe_khach) {
      condition.xe = filter.xe_khach?._id;
    }
    if (filter.trang_thai) {
      condition.trang_thai = filter.trang_thai?.ma_trang_thai;
    }
    if (filter.tg_khoi_hanh_start || filter.tg_khoi_hanh_end) {
      const startDate = moment(filter.tg_khoi_hanh_start).startOf("days");
      const endDate = moment(filter.tg_khoi_hanh_end).endOf("days");
      if (filter.tg_khoi_hanh_start && filter.tg_khoi_hanh_end) {
        condition.tg_khoi_hanh = { $gte: startDate, $lte: endDate };
      } else if (filter.tg_khoi_hanh_start) {
        condition.tg_khoi_hanh = { $gte: startDate };
      } else if (filter.tg_khoi_hanh_end) {
        condition.tg_khoi_hanh = { $lte: endDate };
      }
    }

    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterTimeFromTo
        label="Thời gian khởi hành"
        defaultTimeFrom={filter.tg_khoi_hanh_start}
        defaultTimeTo={filter.tg_khoi_hanh_end}
        onSearch={({ timeFrom, timeTo }) => {
          setFilter({
            ...filter,
            tg_khoi_hanh_start: timeFrom,
            tg_khoi_hanh_end: timeTo,
          });
        }}
      />
      <FilterText
        label="Mã đặt chỗ"
        placeholder="Tìm theo mã đặt chỗ"
        value={filter.ma}
        onSearch={(val) => setFilter({ ...filter, ma: val })}
      />
      <FilterText
        label="Khách hàng"
        placeholder="Tìm theo tên khách hàng"
        value={filter.ten_kh}
        onSearch={(val) => setFilter({ ...filter, ten_kh: val })}
      />
      <FilterText
        label="Số ghế"
        placeholder="Tìm theo số ghế"
        value={filter.ma_ghe}
        onSearch={(val) => setFilter({ ...filter, ma_ghe: val })}
      />
      <FilterSelectApi
        label="Xe khách"
        placeholder="Chọn xe khách"
        selectTitle="Chọn xe khách"
        placeholderSearch="Tìm theo biển số xe"
        apiCode="dmxe"
        getOptionLabel={(option) => `${option.ten_nha_xe} - ${option.bien_so}`}
        checkEqual={(value, option) => value?._id === option?._id}
        searchFields={["bien_so"]}
        value={filter.xe_khach}
        onChange={(val) => setFilter({ ...filter, xe_khach: val })}
      />
      <FilterSelectApi
        label="Trạng thái"
        placeholder="Chọn trạng thái"
        selectTitle="Chọn trạng thái"
        placeholderSearch="Tìm theo tên trạng thái"
        apiCode="trangthai"
        defaultCondition={{ ma_ct: "VEXE" }}
        withIdApp={false}
        getOptionLabel={(option) => option.ten_trang_thai}
        checkEqual={(value, option) =>
          value?.ma_trang_thai === option?.ma_trang_thai
        }
        searchFields={["ma_trang_thai", "ten_trang_thai"]}
        value={filter.trang_thai}
        onChange={(val) => setFilter({ ...filter, trang_thai: val })}
      />
    </WrapperFilter>
  );
}

export default FilterTicketOrder;
